import { render, staticRenderFns } from "./CardInterface.vue?vue&type=template&id=78275ced&scoped=true&"
import script from "./CardInterface.vue?vue&type=script&lang=js&"
export * from "./CardInterface.vue?vue&type=script&lang=js&"
import style0 from "./CardInterface.vue?vue&type=style&index=0&id=78275ced&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78275ced",
  null
  
)

export default component.exports